
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.3 32c-1.5 0-3.2-.2-4.9-.7-.3-.1-.5-.3-.6-.5L17 25.7l-2.7 5.1c-.1.2-.4.4-.6.5-6.8 1.9-12.6-.8-12.9-1-.4-.2-.6-.6-.6-1 0-.3.6-8.1 1.6-12.2 1.3-5 1.6-9.2 1.6-9.2 0-.5.5-.9 1-.9h25.2c.5 0 1 .4 1 .9 0 0 .3 4.3 1.6 9.2.9 4 1.6 11.8 1.6 12.1 0 .4-.2.8-.6 1-.2.3-3.5 1.8-7.9 1.8zm-4-2.5c4.7 1.2 8.9-.1 10.5-.7-.2-2.1-.8-7.9-1.5-11.1-1-3.8-1.4-7.1-1.5-8.6H5.3c-.2 1.6-.6 4.9-1.5 8.6-.8 3.2-1.4 9.1-1.5 11.2 1.6.6 5.8 1.9 10.5.7l3.4-6.4c.2-.3.5-.5.9-.5s.7.2.9.5l3.3 6.3z","fill":"#F9A91E"}}),_c('path',{attrs:{"d":"M3.5 1.3h27v3.8h-27V1.3z","fill":"#47AEA6"}})])
          )
        }
      }
    